/* ============================================================================
   assets/r24-wishlist.js — ausgelagert aus snippets/r24-wishlist.liquid (P2-1, 25.09.2026).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid steht an der alten
   Stelle nur noch der Skript-Tag (Verweis R24-JS-AUSGELAGERT). Pruefung:
   npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
(function () {
  /* Liquid-Werte am eigenen Skript-Tag (nur waehrend des ersten, synchronen Laufs lesbar). */
  var CUR = document.currentScript;
  /* Doppel-Render-Schutz: zwei Instanzen = zwei Capture-Klickpfade, jedes Herz
     schaltete dann an UND wieder aus. Die erste Instanz gewinnt.
     Laedt mit defer (Perf 25.09.2026): bis hierher steht der kleine Inline-Platzhalter
     aus snippets/r24-wishlist.liquid (STUB = stub:1) — er liest den Speicher schon beim
     Parsen (has/all/count, PDP-Anfangszustand) und merkt sich Aufrufe in STUB.q. */
  var STUB = window.R24Wis && window.R24Wis.stub ? window.R24Wis : null;
  if (window.R24Wis && !STUB) return;
  /* ---- Store-API (Variant-Level) ---------------------------------------- */
  var KEY = 'r24_wis_v';
  function readAll() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(function (x) { return x && x.v; }) : []; }
    catch (e) { return []; }
  }
  var subs = [];
  /* Ein fehlerhafter Abonnent darf die anderen nicht aufhalten — verschluckt wird er aber nicht. */
  function emit() { subs.forEach(function (f) { try { f(); } catch (e) { if (typeof console !== 'undefined') console.warn('[R24 Merkliste] Abonnent von R24Wis.on:', e); } }); }
  function refreshCount() {
    var n = readAll().length;
    document.querySelectorAll('[data-count-wishlist], .t4s-count-wishlist, a[data-link-wishlist] .t4s-count-box').forEach(function (el) {
      el.textContent = n; el.style.opacity = n > 0 ? '1' : ''; el.classList.remove('t4s-op-0');
    });
    /* Haken fuer Kopf/Tabbar (A2 fuehrt die Zahl im zugaenglichen Namen): Zahl kommt mit. */
    try { document.dispatchEvent(new CustomEvent('r24wis:count', { detail: { count: n } })); } catch (e) {}
  }
  function writeAll(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} refreshCount(); emit(); }
  /* has(): exakte Variante ODER Produkt-Id. Karten-Herzen arbeiten auf Produkt-Ebene
     ("p<id>" bzw. irgendeine gemerkte Variante des Produkts), das PDP-Herz auf
     Varianten-Ebene — beide lesen so denselben Speicher. Produkt- und Varianten-Ids
     sind bei Shopify getrennte Nummernkreise, eine Verwechslung ist ausgeschlossen. */
  function hasIn(a, v) { v = String(v || ''); return !!v && a.some(function (x) { return String(x.v) === v || String(x.v) === 'p' + v || String(x.p || '') === v; }); }
  function has(v) { return hasIn(readAll(), v); }
  function hasExact(v) { v = String(v || ''); return !!v && readAll().some(function (x) { return String(x.v) === v; }); }
  function add(entry) {
    if (!entry || !entry.v) return;
    var a = readAll().filter(function (x) { return String(x.v) !== String(entry.v); });
    a.unshift(entry); writeAll(a);
  }
  function remove(v) { v = String(v || ''); writeAll(readAll().filter(function (x) { return String(x.v) !== v; })); }
  function removeProduct(pid) { pid = String(pid || ''); writeAll(readAll().filter(function (x) { return !(String(x.v) === 'p' + pid || String(x.p || '') === pid); })); }

  /* ---- EINE höfliche Live-Region für alle Merklisten-Meldungen ------------ */
  var live = null, liveT = 0;
  function ensureLive() {
    if (live || !document.body) return live;
    live = document.getElementById('r24-wis-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'r24-wis-live'; live.className = 'visually-hidden';
      live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true');
      document.body.appendChild(live);
    }
    return live;
  }
  /* leeren + kurz danach setzen → auch die gleiche Meldung wird erneut gesprochen */
  function announce(msg) {
    var el = ensureLive(); if (!el) return;
    el.textContent = ''; clearTimeout(liveT);
    liveT = setTimeout(function () { el.textContent = msg; }, 60);
  }
  var MSG_ADD = 'Zur Merkliste hinzugefügt', MSG_DEL = 'Von der Merkliste entfernt';

  function norm(u) { u = String(u || ''); return u.indexOf('//') === 0 ? 'https:' + u : u; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* erster Treffer in SELEKTOR-Reihenfolge (querySelector mit Liste nimmt Dokument-Reihenfolge) */
  function pick(root, sels) { for (var i = 0; i < sels.length; i++) { var el = root.querySelector(sels[i]); if (el) return el; } return null; }

  /* ---- Produkt-Schnappschuss aus einer Karte (Kategorie/Suche/Startseite/Kalles) */
  function heartPid(b) { return String(b.getAttribute('data-r24-wish') || b.getAttribute('data-id') || '').replace(/\D/g, ''); }
  function snapProduct(pid, btn) {
    if (!btn && /^\d+$/.test(pid)) btn = document.querySelector('[data-r24-wish="' + pid + '"], [data-r24-wish][data-id="' + pid + '"], [data-action-wishlist][data-id="' + pid + '"]');
    var card = btn && btn.closest('.r24col-card, .r24h-card, .t4s-product, .t4s-pr-item, .t4s-col-item, li, article, [data-product-id]');
    var link = card && card.querySelector('a[href*="/products/"]');
    var url = link ? String(link.getAttribute('href') || '').split('#')[0] : '';
    if (!url) return null;
    var tEl = pick(card, ['.r24col-card__title', '.r24h-card__t', '.t4s-product-info__title', '.t4s-product-title', '.t4s-pr-title', '[class*="title"]']);
    var title = ((tEl && tEl.textContent) || link.getAttribute('aria-label') || link.textContent || 'Produkt').replace(/\s+/g, ' ').replace(/\s*\((?:Kopie|Copy)\)\s*$/i, '').trim();
    var im = card.querySelector('img');
    var pEl = pick(card, ['.r24col-card__now', '.r24h-card__now', '.t4s-product-price', '.t4s-price', '[class*="price"]']);
    return { v: 'p' + pid, p: pid, h: '', t: title, opt: '', img: im ? norm(im.getAttribute('src') || im.getAttribute('data-src') || '') : '',
      price: pEl ? (pEl.textContent || '').replace(/\s+/g, ' ').trim() : '', url: url };
  }
  /* Umschalten auf Produkt-Ebene. true/false = neuer Zustand, null = nichts Verwertbares. */
  function flipProduct(pid, btn) {
    pid = String(pid || ''); if (!pid) return null;
    if (has(pid)) { removeProduct(pid); announce(MSG_DEL); return false; }
    var snap = snapProduct(pid, btn); if (!snap) return null;
    add(snap); announce(MSG_ADD); return true;
  }
  /* toggle(entry) — Variante (PDP, Objekt) ODER Produkt-Id (Karten, Zahl/String).
     Vorher lief toggle('123') (Kategorie/Suche) ins Leere: entry.v war undefined. */
  function toggle(entry) {
    if (!entry) return false;
    if (typeof entry !== 'object') return !!flipProduct(entry);
    if (!entry.v) return false;
    var on = !hasExact(entry.v);
    if (on) add(entry); else remove(entry.v);
    announce(on ? MSG_ADD : MSG_DEL);
    return on;
  }

  /* ---- Herz-Zustand ZENTRAL (alle Flächen) ----------------------------------
     Jedes Herz bekommt aria-pressed + einen Namen, der die Aktion nennt. Karten-
     Owner (Startseite, Kategorie/Suche, PDP) bauen KEINE eigene Zustandslogik. */
  var LBL_OFF = 'Auf die Merkliste', LBL_ON = 'Von der Merkliste entfernen';
  var HEARTS = '[data-r24-wish], [data-action-wishlist][data-id], [data-r24pd] [data-wish], [data-r24pd] [data-merken]';
  function heartOn(b, items) {
    if (b.hasAttribute('data-wish') || b.hasAttribute('data-merken')) {
      var pd = b.closest('[data-r24pd]'), vi = pd && pd.querySelector('[data-variant-id]');
      var vid = vi ? String(vi.value || '') : '';
      return !!vid && items.some(function (x) { return String(x.v) === vid; });
    }
    return hasIn(items, heartPid(b));
  }
  function paintHeart(b, on) {
    var cls = b.classList.contains('r24h-wish') ? 'is--on' : (b.hasAttribute('data-action-wishlist') ? 'r24-wis-on' : 'is-on');
    b.classList.toggle(cls, on);
    /* Kalles-Herzen sind <a>-Links: aria-pressed ist dort ungueltig → nur der Name traegt den Zustand. */
    if (b.tagName !== 'A') b.setAttribute('aria-pressed', on ? 'true' : 'false');
    /* Taste mit sichtbarem Text („Merken"/„Gemerkt") behaelt ihren Namen (WCAG 2.5.3). */
    if (!b.hasAttribute('data-merken')) { var n = heartName(b); b.setAttribute('aria-label', (on ? LBL_ON : LBL_OFF) + (n ? ': ' + n : '')); }
  }
  /* Karten-Herzen nennen das Produkt („Auf die Merkliste: Tisch Oslo“) — in einem
     Raster mit 24 Karten waeren sonst 24 gleichnamige Knoepfe (A4/5 hatte den Titel
     schon im Markup, die zentrale Beschriftung darf ihn nicht wieder loeschen).
     PDP-Herz: eine Seite = ein Produkt, dort genuegt die Aktion. Gemerkt je Knopf. */
  function heartName(b) {
    if (b.__r24n != null) return b.__r24n;
    var n = '';
    if (!b.hasAttribute('data-wish')) {
      var card = b.closest('.r24col-card, .r24h-card, .t4s-product, .t4s-pr-item, .t4s-col-item, li, article, [data-product-id]');
      var tEl = card && pick(card, ['.r24col-card__title', '.r24h-card__t', '.t4s-product-info__title', '.t4s-product-title', '.t4s-pr-title']);
      if (tEl) n = (tEl.textContent || '').replace(/\s+/g, ' ').replace(/\s*\((?:Kopie|Copy)\)\s*$/i, '').trim().slice(0, 120);
    }
    return (b.__r24n = n);
  }
  function syncHearts() {
    var items = readAll();
    document.querySelectorAll(HEARTS).forEach(function (b) { paintHeart(b, heartOn(b, items)); });
  }
  var syncT = 0;
  function queueSync() { clearTimeout(syncT); syncT = setTimeout(syncHearts, 0); }

  window.R24Wis = {
    KEY: KEY, all: readAll, has: has, add: add, remove: remove, toggle: toggle,
    count: function () { return readAll().length; }, refreshCount: refreshCount,
    on: function (f) { if (typeof f === 'function') subs.push(f); },
    sync: syncHearts, announce: announce
  };
  /* Aufrufe, die vor diesem Skript ueber den Platzhalter kamen (on/toggle/…), jetzt
     echt ausfuehren — in ihrer Reihenfolge. */
  if (STUB) (STUB.q || []).forEach(function (c) {
    try { window.R24Wis[c[0]].apply(null, c[1]); } catch (e) { if (typeof console !== 'undefined') console.warn('[R24 Merkliste] vorgemerkter Aufruf ' + c[0] + ':', e); }
  });

  /* ---- EIN Klick-Pfad fuer alle Produkt-Herzen (Capture, vor den Karten-Skripten) ----
     [data-r24-wish] (Kategorie/Suche/Startseite/Zuletzt angesehen) und Kalles
     [data-action-wishlist] (Quick-View) schreiben in DENSELBEN Speicher r24_wis_v.
     stopPropagation: die alten Karten-Handler (t4s_wis bzw. R24Wis.toggle(id))
     laufen nicht zusaetzlich — sonst wuerde doppelt umgeschaltet. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-r24-wish], [data-action-wishlist]') : null;
    if (!b) return;
    var pid = heartPid(b);
    if (!pid || (!has(pid) && !snapProduct(pid, b))) return; /* nichts Verwertbares → fremde Logik weiterlaufen lassen */
    e.preventDefault(); e.stopPropagation();
    flipProduct(pid, b);
  }, true);
  /* PDP: Variantenwechsel setzt nur die Klasse (r24-product-main) → danach Zustand neu lesen. */
  function pdpResync(e) { if (e.target && e.target.closest && e.target.closest('[data-r24pd]')) queueSync(); }
  document.addEventListener('click', pdpResync);
  document.addEventListener('change', pdpResync);

  /* ---- Merkliste-Seite (/search?view=wishlist): eigenes Variant-Raster -------
     Der Kopf mit der EINZIGEN H1 steht serverseitig in templates/search.wishlist.liquid
     (#r24-wisv). Hier: native Kalles-Liste ausblenden, Karten zeichnen, Aktionen. */
  var ALL_URL = (CUR && CUR.getAttribute('data-all-url')) || '/collections/all';
  var EMPTY = '<div class="r24-wisv-empty"><i class="las la-heart" aria-hidden="true"></i>' +
    '<h2>Ihre Merkliste ist leer</h2><p>Merken Sie sich Artikel in Ihrer Wunschfarbe — jede Variante wird einzeln gespeichert.</p>' +
    '<a href="' + esc(ALL_URL) + '">Produkte entdecken</a></div>';
  var UPD = '<span class="visually-hidden"> (Preis seit dem Merken aktualisiert)</span>';
  function itemName(it) { return (it && it.t ? it.t : 'Artikel') + (it && it.opt ? ' (' + it.opt + ')' : ''); }

  function renderPage() {
    var wrap = document.getElementById('r24-wisv');
    if (!wrap) return; /* nicht auf der Merkliste */
    var nativeBox = document.querySelector('.t4s-products-wishlist') || document.querySelector('.t4s_empty_wishlist_page');
    var section = nativeBox && (nativeBox.closest('.t4s-section-inner') || nativeBox.parentNode);
    if (section) section.classList.add('r24-wis-owned');
    if (!wrap.hasAttribute('data-r24-bound')) {
      wrap.setAttribute('data-r24-bound', '');
      wrap.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-r24-rm]');
        if (rm) { removeCard(rm); return; }
        var atc = e.target.closest('[data-r24-atc]');
        if (atc) { addToCart(atc); return; }
        if (e.target.closest('[data-r24-wisv-clear]')) clearAll();
      });
    }
    paint();
  }

  /* Entfernen: Ansage mit Artikelname, Fokus auf die naechste Entfernen-Taste
     (bzw. die vorige, wenn es die letzte Karte war) oder auf die H1. */
  function removeCard(rm) {
    var v = rm.getAttribute('data-r24-rm');
    var all = [].slice.call(document.querySelectorAll('#r24-wisv [data-r24-rm]'));
    var idx = all.indexOf(rm);
    var it = readAll().filter(function (x) { return String(x.v) === String(v); })[0];
    remove(v); paint();
    announce(itemName(it) + ' von der Merkliste entfernt');
    var left = document.querySelectorAll('#r24-wisv [data-r24-rm]');
    var target = left.length ? left[Math.min(Math.max(idx, 0), left.length - 1)] : document.getElementById('r24-wisv-title');
    if (target) target.focus();
  }
  /* Bestaetigung im Hausstil (26.09.2026): natives <dialog> mit showModal — Fokusfalle, Esc,
     Rueckgabe des Fokus und Vorlesen macht der Browser. Ohne <dialog>-Unterstuetzung (alte
     Browser, Testumgebung) bleibt window.confirm. Rueckruf statt Promise: kein Polyfill noetig. */
  function askConfirm(text, okLabel, done) {
    var D = window.HTMLDialogElement;
    if (!D || typeof D.prototype.showModal !== 'function') { done(window.confirm(text)); return; }
    if (!document.getElementById('r24-wis-dlg-css')) {
      var st = document.createElement('style'); st.id = 'r24-wis-dlg-css';
      st.textContent =
        '.r24-wis-dlg{border:0;padding:0;border-radius:var(--r24-radius,14px);max-width:min(420px,calc(100vw - 32px));' +
        'box-shadow:var(--r24-shadow-soft,0 10px 28px -16px rgba(0,0,0,.25));font-family:var(--r24h-font,inherit);color:var(--r24h-ink,#262A31)}' +
        '.r24-wis-dlg::backdrop{background:rgba(20,24,30,.42)}' +
        '.r24-wis-dlg__in{padding:24px 24px 20px}' +
        '.r24-wis-dlg__t{margin:0 0 18px;font-family:var(--r24h-display,Georgia,serif);font-weight:500;font-size:var(--r24-fs-lg,20px);line-height:1.3}' +
        '.r24-wis-dlg__row{display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap}' +
        '.r24-wis-dlg__b{min-height:44px;padding:0 18px;border-radius:var(--r24-radius-sm,10px);font:inherit;font-size:var(--r24-fs-base,15px);font-weight:600;cursor:pointer}' +
        '.r24-wis-dlg__b--no{background:#fff;color:var(--r24h-ink,#262A31);border:1px solid var(--r24h-line-3,#d9dbde)}' +
        '.r24-wis-dlg__b--ok{background:var(--r24h-ink,#262A31);color:#fff;border:1px solid var(--r24h-ink,#262A31)}' +
        '.r24-wis-dlg__b:focus-visible{outline:2px solid var(--r24-focus,#0a7c42);outline-offset:2px}';
      document.head.appendChild(st);
    }
    var dlg = document.createElement('dialog');
    dlg.className = 'r24-wis-dlg';
    dlg.setAttribute('aria-labelledby', 'r24-wis-dlg-t');
    dlg.innerHTML = '<form method="dialog" class="r24-wis-dlg__in">' +
      '<p class="r24-wis-dlg__t" id="r24-wis-dlg-t">' + esc(text) + '</p>' +
      '<div class="r24-wis-dlg__row">' +
        '<button class="r24-wis-dlg__b r24-wis-dlg__b--no" value="no" autofocus>Abbrechen</button>' +
        '<button class="r24-wis-dlg__b r24-wis-dlg__b--ok" value="ok">' + esc(okLabel) + '</button>' +
      '</div></form>';
    /* Entscheidung sofort beim Klick (nicht erst im close-Ereignis — das kommt in verdeckten
       Tabs verzoegert); finish() laeuft genau einmal. Esc → cancel/close → Abbrechen. */
    var fin = false;
    function finish(yes) {
      if (fin) return; fin = true;
      if (dlg.open) { try { dlg.close(yes ? 'ok' : 'no'); } catch (e) {} }
      if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
      done(yes);
    }
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[value]');
      if (b) { e.preventDefault(); finish(b.value === 'ok'); return; }
      /* Klick auf den abgedunkelten Rand = Abbrechen. */
      if (e.target === dlg) finish(false);
    });
    dlg.addEventListener('cancel', function () { finish(false); });
    dlg.addEventListener('close', function () { finish(dlg.returnValue === 'ok'); });
    document.body.appendChild(dlg);
    try { dlg.showModal(); } catch (e) { if (dlg.parentNode) dlg.parentNode.removeChild(dlg); done(window.confirm(text)); }
  }
  /* „Alle entfernen": Bestaetigung mit Anzahl → kein versehentlicher Datenverlust; danach Fokus auf die H1. */
  function clearAll() {
    var n = readAll().length; if (!n) return;
    askConfirm((n === 1 ? 'Den Artikel' : 'Alle ' + n + ' Artikel') + ' von der Merkliste entfernen?', 'Entfernen', function (yes) {
      if (!yes) return;
      writeAll([]); paint();
      announce('Alle Artikel von der Merkliste entfernt');
      var t = document.getElementById('r24-wisv-title'); if (t) t.focus();
    });
  }

  function card(it) {
    var img = norm(it.img), name = itemName(it);
    var imgHtml = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '';
    var opt = it.opt ? '<span class="r24-wisv-card__opt"><i class="las la-tag" aria-hidden="true"></i>' + esc(it.opt) + '</span>' : '';
    var price = it.price ? '<div class="r24-wisv-card__price' + (it.pupd ? ' is--updated' : '') + '"' +
      (it.pupd ? ' title="Preis wurde seit dem Merken aktualisiert"' : '') + '>' + esc(it.price) + (it.pupd ? UPD : '') + '</div>' : '';
    var isVar = String(it.v).charAt(0) !== 'p';
    var atc = isVar
      ? '<button type="button" class="r24-wisv-card__btn r24-wisv-card__btn--atc" data-r24-atc="' + esc(it.v) + '"><i class="las la-shopping-cart" aria-hidden="true"></i>In den Warenkorb</button>'
      : '';
    /* Bild-Link doppelt den Titel-Link → raus aus Tab-Folge und Baum (vorher: Link ohne Namen). */
    return '<div class="r24-wisv-card" role="listitem" data-r24-v="' + esc(it.v) + '">' +
      '<a class="r24-wisv-card__imgwrap" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
      '<button type="button" class="r24-wisv-card__rm" data-r24-rm="' + esc(it.v) + '" aria-label="' + esc(name) + ' von der Merkliste entfernen">&times;</button>' +
      '<div class="r24-wisv-card__body">' +
        '<a class="r24-wisv-card__t" href="' + esc(it.url) + '">' + esc(it.t) + '</a>' +
        opt + price +
        '<div class="r24-wisv-card__acts">' + atc +
          '<a class="r24-wisv-card__btn r24-wisv-card__btn--view" href="' + esc(it.url) + '"><i class="las la-eye" aria-hidden="true"></i>Ansehen<span class="visually-hidden">: ' + esc(name) + '</span></a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function paint() {
    var wrap = document.getElementById('r24-wisv'); if (!wrap) return;
    var grid = wrap.querySelector('[data-r24-wisv-grid]');
    var countEl = wrap.querySelector('[data-r24-wisv-count]');
    var items = readAll();
    var clr = wrap.querySelector('[data-r24-wisv-clear]'); if (clr) clr.hidden = !items.length;
    if (countEl) countEl.textContent = items.length + ' Artikel';
    var empty = wrap.querySelector('.r24-wisv-empty');
    if (!items.length) {
      grid.innerHTML = ''; grid.removeAttribute('role'); grid.removeAttribute('aria-labelledby');
      if (!empty) wrap.insertAdjacentHTML('beforeend', EMPTY);
      return;
    }
    if (empty) empty.remove();
    grid.setAttribute('role', 'list'); grid.setAttribute('aria-labelledby', 'r24-wisv-title');
    grid.innerHTML = items.map(card).join('');
    verifyItems();
  }

  /* ---- Merkliste gegen den Shop abgleichen --------------------------------
     Die Karten werden aus localStorage gezeichnet — einem Schnappschuss vom
     Zeitpunkt des Merkens. Ohne Abgleich zeigt die Liste gelöschte Artikel mit
     altem Preis und führt beim Klick auf 404. Deshalb: jede Karte gegen
     /products/<handle>.js prüfen, verschwundene deutlich kennzeichnen (nicht
     heimlich löschen — der Nutzer entscheidet) und veraltete Preise korrigieren. 
 Begrenzt (A16-04): EIN Abruf je Handle und Seitenaufruf (Promise-Cache, auch
     mehrere Farben desselben Artikels teilen ihn), hoechstens 4 gleichzeitig.
     Entfernen/Neuzeichnen liest nur den Cache \u2192 0 neue Anfragen. Als \u201Eentfernt"
     gilt nur ein 404 \u2014 Netzfehler/429/5xx behaupten nichts. 
 R24 · Abrufregel (fetch-hardening, 21.09.2026) — gleichlautend in r24-cart,
     r24-wishlist, r24-home-cart-js, r24-set-konfigurator, r24-kuechenplaner-js
     (Vertrag: scripts/fetch-hardening.contract.test.mjs). Verwirft NIE und
     liefert {ok, status, data, text, kind, url} (text = roher Body, seit 23.09.2026 fuer HTML-Abrufe):
       data  nur, wenn der Body wie JSON aussieht — Shopifys .js-Antworten kommen
             als text/javascript, Drossel- und Fehlerseiten als HTML; nie mehr
             JSON.parse auf „<!DOCTYPE"
       kind  ok | empty (2xx ohne lesbares JSON) | rate (429) | server (5xx) |
             client (andere 4xx) | network | timeout (Zeitlimit per AbortController)
     retry: bei 429 hoechstens EIN verzoegerter zweiter Versuch — nur fuer den
     Klick des Kunden; Hintergrundabrufe wiederholen nie. */
  function r24Fetch(url, init, retry, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0, o = {}, k;
    for (k in (init || {})) o[k] = init[k];
    if (ctl) { o.signal = ctl.signal; tm = setTimeout(function () { ctl.abort(); }, ms || 20000); }
    return fetch(url, o).then(function (r) {
      return r.text().then(function (t) {
        clearTimeout(tm);
        var d = null, s = r.status, wait;
        if (/^\s*[\[{]/.test(t || '')) { try { d = JSON.parse(t); } catch (e) { d = null; } }
        if (s === 429 && retry) {
          wait = Math.min(4, Math.max(1, parseFloat(r.headers && r.headers.get('Retry-After')) || 1.5));
          return new Promise(function (go) { setTimeout(go, wait * 1000); }).then(function () { return r24Fetch(url, init, false, ms); });
        }
        return { ok: r.ok, status: s, data: d, text: t || '', url: r.url || '',
          kind: r.ok ? (d ? 'ok' : 'empty') : s === 429 ? 'rate' : s >= 500 ? 'server' : 'client' };
      });
    }).then(null, function (e) {
      clearTimeout(tm);
      var to = !!(e && e.name === 'AbortError');
      if (typeof console !== 'undefined') console.warn('[R24] ' + url + ': ' + (to ? 'Zeitlimit' : (e && e.message) || e));
      return { ok: false, status: 0, data: null, text: '', url: '', kind: to ? 'timeout' : 'network' };
    });
  }
  var FAIL = {
    rate: 'Gerade ausgelastet – bitte gleich erneut versuchen',
    server: 'Shop antwortet nicht – bitte erneut versuchen',
    network: 'Keine Verbindung – bitte erneut versuchen',
    timeout: 'Keine Antwort – bitte Warenkorb prüfen'
  };

  var PJ = {}, pq = [], active = 0, MAXP = 4;
  function pump() { while (active < MAXP && pq.length) { active++; pq.shift()(); } }
  function productJson(h) {
    if (!PJ[h]) PJ[h] = new Promise(function (res) {
      pq.push(function () {
        /* Hintergrund-Abgleich: kein zweiter Versuch. Produkt nur mit lesbarem
           JSON; null = 404 (entfernt); undefined = unbekannt (429/5xx/Netz/HTML). */
        r24Fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (x) {
            active--; pump();
            var val = x.ok && x.data ? x.data : (x.status === 404 ? null : undefined);
            /* „unbekannt“ nicht fuer die ganze Seite merken — der naechste Aufruf fragt neu. */
            if (val === undefined) delete PJ[h];
            res(val);
          });
      });
      pump();
    });
    return PJ[h];
  }
  function handleOf(it) {
    var url = String(it.url || '');
    return url.indexOf('/products/') === -1 ? '' : url.split('/products/')[1].split('?')[0].split('#')[0].replace(/\/.*$/, '');
  }
  function digits(s) { return String(s || '').replace(/[^\d,]/g, ''); }
  /* ---- „Jetzt günstiger" (Runde 3, R24 Luxe) --------------------------------
     Gemerkt wird der Preistext von Karte bzw. Produktseite: „1.989,99 €", „€1.989,99"
     (Shop-Format vor r24-currency-format), „ab 199,00 €", „jetzt 1.989,99 €", „199,- €".
     r24EuroCents liest daraus Cent — aber NUR bei genau EINEM Betrag im Text; ein
     Streichpreis-Paar („1.989,99 € 2.149,99 €"), englische Schreibweise oder gar keine
     Zahl ergeben null. Tausender: Punkt/schmale Leerzeichen/Apostroph, Dezimal: Komma. */
  function r24EuroCents(s) {
    var hits = String(s == null ? '' : s).match(/\d{1,3}(?:[.\u00a0\u202f\u2009']\d{3})+(?:,(?:\d{1,2}|-{1,2}))?(?!\d)|\d+(?:,(?:\d{1,2}|-{1,2}))?(?!\d)/g) || [];
    if (hits.length !== 1) return null;
    var parts = hits[0].split(','), euros = parseInt(parts[0].replace(/\D/g, ''), 10);
    var dec = parts[1] && /^\d+$/.test(parts[1]) ? parseInt((parts[1] + '0').slice(0, 2), 10) : 0;
    if (!isFinite(euros)) return null;
    var c = euros * 100 + dec;
    return c > 0 ? c : null;
  }
  /* Behauptet wird „günstiger" nur mit BEIDEN Werten: lesbarer Merkpreis UND aktueller
     Shop-Preis (Cent aus /products/<h>.js), Unterschied mindestens 1 € (keine Rundungs-
     Cent-Meldungen). Sonst null = keine Aussage. */
  function r24PriceDrop(savedText, currentCents) {
    var was = r24EuroCents(savedText);
    if (was == null || typeof currentCents !== 'number' || !isFinite(currentCents) || currentCents <= 0) return null;
    return was - currentCents >= 100 ? { was: was, now: currentCents } : null;
  }
  function euroText(c) {
    try { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC'; }
    catch (e) { return (c / 100).toFixed(2) + ' \u20AC'; }
  }
  /* Hinweis an der Karte — nur Knoten + textContent, nie HTML aus gespeicherten Texten. */
  function markDrop(card, drop) {
    var old = card.querySelector('.r24-wisv-card__drop');
    if (!drop) { if (old) old.remove(); return; }
    var n = old || document.createElement('p');
    n.className = 'r24-wisv-card__drop';
    n.textContent = '';
    var b = document.createElement('strong'); b.textContent = 'Jetzt günstiger'; n.appendChild(b);
    n.appendChild(document.createTextNode(' · gemerkt zu '));
    var s = document.createElement('s'); s.textContent = euroText(drop.was); n.appendChild(s);
    if (!old) { var pe = card.querySelector('.r24-wisv-card__price'); if (pe && pe.parentNode) pe.parentNode.insertBefore(n, pe.nextSibling); }
  }
  /* Zuschnitt auf Mass (Arbeitsplatten, snippets/r24-pdp-zuschnitt): die Wunschlaenge
     ist Pflicht und wird auf der Produktseite eingegeben. Direkt aus der Merkliste in
     den Warenkorb ginge sie verloren → dort fuehrt der Knopf zur Produktseite. 
 EINE Regel mit Produktseite und Konto: Kopie der JS-Fassung aus snippets/r24-is-cut
     (Typ/Tag UND Längen-Option mit >= 2 Bereichen); scripts/luxe-pdp.contract.test.mjs
     haelt beide gleich. */
  function isCut(p) {
    if (!p) return false;
    var typ = /arbeitsplatte/i.test(String(p.type || '')) || (p.tags || []).indexOf('r24-zuschnitt') > -1;
    if (!typ) return false;
    return (p.options || []).some(function (o) { return !!o && /l(ä|ae)nge/i.test(String(o.name || '')) && (o.values || []).length >= 2; });
  }
  function cutUrl(card, v) {
    var view = card && card.querySelector('.r24-wisv-card__btn--view');
    var u = view ? String(view.getAttribute('href') || '') : '';
    if (!u) return '';
    /* Gespeicherte Adresse traegt oft schon ?variant= → ersetzen statt doppelt anhaengen. */
    try {
      var x = new URL(u.split('#')[0], location.origin);
      if (/^\d+$/.test(String(v))) x.searchParams.set('variant', v);
      return x.pathname + x.search;
    } catch (e) { return u.split('#')[0]; }
  }
  function markCut(card, v) {
    var atc = card && card.querySelector('[data-r24-atc]');
    if (!atc || atc.hasAttribute('data-r24-cut')) return;
    atc.setAttribute('data-r24-cut', cutUrl(card, v));
    atc.innerHTML = '<i class="las la-cut" aria-hidden="true"></i>Maß angeben';
    atc.setAttribute('aria-label', 'Maß angeben: ' + ((card.querySelector('.r24-wisv-card__t') || {}).textContent || 'Artikel').trim());
  }
  function verifyItems() {
    var wrap = document.getElementById('r24-wisv'); if (!wrap) return;
    readAll().forEach(function (it) {
      var h = handleOf(it); if (!h) return;
      productJson(h).then(function (p) {
        if (p === undefined) return;
        /* Karte erst JETZT suchen: sie kann inzwischen neu gezeichnet oder entfernt sein. */
        var card = wrap.querySelector('.r24-wisv-card[data-r24-v="' + String(it.v).replace(/["\\]/g, '') + '"]');
        if (!card) return;
        if (!p) { markGone(card); return; }
        if (isCut(p)) markCut(card, it.v);
        var isVar = String(it.v).charAt(0) !== 'p';
        var vr = isVar ? (p.variants || []).filter(function (x) { return String(x.id) === String(it.v); })[0] : null;
        if (isVar && !vr) { markGone(card); return; }
        var cents = vr ? vr.price : p.price;
        if (typeof cents !== 'number') return;
        var neu;
        try { neu = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC'; }
        catch (e) { neu = (cents / 100).toFixed(2) + ' \u20AC'; }
        var pe = card.querySelector('.r24-wisv-card__price');
        var cur = readAll().filter(function (x) { return String(x.v) === String(it.v); })[0];
        /* „Jetzt günstiger": gegen den Preis beim MERKEN (p0), nie gegen einen spaeter
           nachgefuehrten. Eintraege, die vor dieser Regel schon nachgefuehrt wurden
           (pupd ohne p0), kennen ihren Merkpreis nicht mehr → keine Aussage. */
        if (pe && cur) markDrop(card, r24PriceDrop(cur.p0 || (cur.pupd ? '' : cur.price), cents));
        /* Vergleich nur der Ziffern ("ab 199,00 \u20AC" == "199,00 \u20AC") gegen den gespeicherten Preis */
        if (!pe || !cur || digits(cur.price) === digits(neu)) return;
        pe.innerHTML = esc(neu) + UPD;
        pe.classList.add('is--updated');
        pe.title = 'Preis wurde seit dem Merken aktualisiert';
        var all = readAll();
        /* Merkpreis EINMAL sichern (p0), bevor der angezeigte Preis nachgefuehrt wird. */
        all.forEach(function (x) { if (String(x.v) === String(it.v)) { if (!x.p0 && !x.pupd) x.p0 = x.price; x.price = neu; x.pupd = 1; } });
        try { localStorage.setItem(KEY, JSON.stringify(all)); } catch (e) {}
      });
    });
  }

  function markGone(card) {
    if (!card || card.classList.contains('is--gone')) return;
    card.classList.add('is--gone');
    var atc = card.querySelector('[data-r24-atc]');
    if (atc) { atc.setAttribute('disabled', 'disabled'); atc.innerHTML = 'Nicht mehr verf\u00FCgbar'; }
    var view = card.querySelector('.r24-wisv-card__btn--view');
    if (view) { view.removeAttribute('href'); view.classList.add('is--dead'); view.textContent = 'Artikel entfernt'; }
    var body = card.querySelector('.r24-wisv-card__body');
    if (body && !card.querySelector('.r24-wisv-card__gone')) {
      var n = document.createElement('div');
      n.className = 'r24-wisv-card__gone';
      n.textContent = 'Dieser Artikel wird nicht mehr gef\u00FChrt.';
      body.insertBefore(n, body.firstChild);
    }
  }

  function addToCart(btn) {
    var v = btn.getAttribute('data-r24-atc'); if (!v) return;
    var card = btn.closest('.r24-wisv-card');
    var cut = btn.getAttribute('data-r24-cut');
    if (cut) { location.href = cut; return; }
    /* Noch nicht geprueft (Klick vor dem Abgleich)? Aus dem Cache nachsehen. */
    var view = card && card.querySelector('.r24-wisv-card__btn--view');
    var h = view ? handleOf({ url: view.getAttribute('href') }) : '';
    if (h && !btn.__r24cutChecked) {
      btn.__r24cutChecked = 1;
      /* Unbekannt (429/5xx/Netz/Zeitlimit) = koennte eine Arbeitsplatte sein: dann NIE ohne
         Zuschnittlaenge in den Warenkorb, sondern auf die Produktseite der Variante (Review R5). */
      productJson(h).then(function (p) {
        if (p === undefined || isCut(p)) { if (isCut(p)) markCut(card, v); location.href = btn.getAttribute('data-r24-cut') || cutUrl(card, v); }
        else addToCart(btn);
      });
      return;
    }
    btn.setAttribute('disabled', 'disabled');
    var IDLE = '<i class="las la-shopping-cart" aria-hidden="true"></i>In den Warenkorb';
    function cartEvents() { ['cart:refresh', 'on:cart:add', 'cart:updated'].forEach(function (ev) { try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) { if (typeof console !== 'undefined') console.warn('[R24 Merkliste] ' + ev + ':', e); } }); }
    r24Fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v, quantity: 1 })
    }, true).then(function (x) {
      if (!x.ok) {
        /* Vorher: JEDER Fehler (auch 429/Netz) leitete kommentarlos auf die
           Produktseite um — bei „offline" ins Leere, bei einer entfernten Karte
           sogar nach „/null". Jetzt bleibt der Kunde hier und liest den Grund. */
        var d = x.data && x.data.description;
        var msg = x.kind === 'client' && d ? String(d).slice(0, 80) : (FAIL[x.kind] || 'Nicht hinzugefügt');
        var t = card && card.querySelector('.r24-wisv-card__t');
        if (x.kind === 'timeout') cartEvents();
        btn.textContent = msg; btn.classList.add('is--err');   /* Grund darf umbrechen (Review R3) */
        announce(((t && t.textContent) || 'Artikel').trim() + ' nicht in den Warenkorb gelegt: ' + msg);
        setTimeout(function () { btn.removeAttribute('disabled'); btn.classList.remove('is--err'); btn.innerHTML = IDLE; }, 3500);
        return;
      }
      /* 2xx = angenommen, auch ohne lesbaren Body (Mini-Cart zeigt den echten Stand). */
      btn.classList.add('is--done'); btn.innerHTML = '<i class="las la-check" aria-hidden="true"></i>Im Warenkorb';
      /* Kalles-Mini-Cart aktualisieren/öffnen (best effort). */
      cartEvents();
      var opener = document.querySelector('[href="#t4s-mini_cart"], [data-toggle="#t4s-mini_cart"], [data-open-minicart]');
      if (opener) opener.click();
      setTimeout(function () { btn.removeAttribute('disabled'); btn.classList.remove('is--done'); btn.innerHTML = IDLE; }, 2600);
    });
  }

  function boot() { ensureLive(); refreshCount(); syncHearts(); renderPage(); }
  /* setTimeout: nach den DOMContentLoaded-Handlern der Sektionen (die teils noch
     eigene Klassen setzen) → der zentrale Zustand gewinnt. Mit defer laeuft diese
     Datei VOR DOMContentLoaded bei readyState "interactive" — ob das Ereignis schon
     kam, weiss nur der Platzhalter (STUB.dcl). */
  if (document.readyState === 'loading' || (STUB && !STUB.dcl)) document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else boot();
  /* load: nur Zaehler + Herzen nachziehen — die Seite NICHT neu zeichnen (A16-04). */
  window.addEventListener('load', function () { refreshCount(); syncHearts(); });
  R24Wis.on(syncHearts);
  /* Neu eingefuegte Karten: Kategorie/Suche (Nachladen + Filterwechsel) und Startseite (Zuletzt angesehen). */
  document.addEventListener('r24col:updated', queueSync);
  document.addEventListener('r24h:paint-wish', queueSync);
  /* anderer Tab hat die Merkliste geaendert */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { refreshCount(); syncHearts(); paint(); } });
})();
